/**
 * Loads chatbot QA aggregates from reporting-service.
 */

import { botReportingQaApiClient } from "@/api/BotReportingQaApiClient";

const SCOPE = "BotQaReportingService";

export class BotQaReportingService {
  constructor(apiClient = botReportingQaApiClient) {
    this.apiClient = apiClient;
  }

  /**
   * @param {unknown} payload
   * @param {string} label
   */
  _unwrap(payload, label) {
    if (!payload || typeof payload !== "object") {
      throw new Error(`${label}: invalid response`);
    }
    const o = /** @type {Record<string, unknown>} */ (payload);
    if (o.error) {
      throw new Error(String(o.error));
    }
    return payload;
  }

  /**
   * @param {{ startDate: string, endDate: string }} range
   * @param {AbortSignal} [signal]
   */
  async load(range, signal) {
    const init = signal ? { signal } : {};
    const [qaAnalysis, qaScorePercentages] = await Promise.all([
      this.apiClient.getQaAnalysis(range, init).then((p) => this._unwrap(p, "qa-analysis")),
      this.apiClient.getQaScorePercentages(range, init).then((p) => this._unwrap(p, "qa-score-percentages")),
    ]);
    return { qaAnalysis, qaScorePercentages };
  }

  /**
   * @param {Error} err
   */
  logError(err) {
    if (typeof console !== "undefined" && console.error) {
      console.error(`[${SCOPE}]`, { message: err?.message ?? String(err) });
    }
  }
}

export const botQaReportingService = new BotQaReportingService();
